<template>
  <div class="review">
    <div class="review__questions-wrapper">
      <h3 class="review__title">Questions You Missed:</h3>
      <ReviewQuestion
        v-for="(question, i) in missedQuestions"
        :key="`review-question-${i}`"
        class="review__question"
        :question="question"
      />
    </div>
  </div>
</template>

<script>
import ReviewQuestion from './ReviewQuestion.vue'

export default {
  name: 'ReviewQuestions',
  components: {
    ReviewQuestion,
  },
  props: {
    missedQuestions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.review {
  display: flex;
  flex-direction: column;
  @include desktop {
    flex-direction: row;
    margin: 30px 0 0 0;
    padding: 0 0 100px 0;
    max-width: 90%;
  }
  &__title {
    margin: 0 0 75px 0;
    padding: 0;
    font-size: 32px;
    font-weight: 500;
  }
  &__questions-wrapper {
    max-width: 1800px;
    width: 100%;
  }
  &__question {
    display: flex;
    font-size: 18px;
    flex-wrap: wrap;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--tundora-gray);
    margin-bottom: 30px;
    @include mobile {
      flex-wrap: nowrap;
    }
  }
}
</style>
